import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(activity)/diva-eyeglasses/components/DivaEyeglassesContent.tsx");
